import { ChangeEvent, forwardRef, memo, useImperativeHandle } from 'react';
import { useMask } from '@react-input/mask';
import { MASK_OPTIONS, toDigits, toMasked, track } from './phone-input.utils';
import { PhoneInputProps } from './phone-input.types';
import { ReactComponent as PhoneIcon } from 'assets/icons/phone.svg';
import { Input } from '../input';

export const PhoneInput = memo(
  forwardRef<HTMLInputElement, PhoneInputProps>(
    ({ value, defaultValue, onChange, onChangeDigits, ...rest }, ref) => {
      const maskRef = useMask({ ...MASK_OPTIONS, track, showMask: true });
      useImperativeHandle(ref, () => maskRef.current, [maskRef]);

      const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        onChange?.(event);
        onChangeDigits?.(toDigits(event.target.value));
      };

      return (
        <Input
          ref={maskRef}
          type="tel"
          inputMode="tel"
          prefix={<PhoneIcon aria-hidden />}
          placeholder={MASK_OPTIONS.mask}
          value={value !== undefined ? toMasked(value) : undefined}
          defaultValue={
            defaultValue !== undefined ? toMasked(defaultValue) : undefined
          }
          onChange={handleChange}
          {...rest}
        />
      );
    }
  )
);

PhoneInput.displayName = 'PhoneInput';
